import React, { Component, Fragment } from 'react';
import api from './../../../services/api';
import { withRouter } from 'react-router-dom';

//import da API
import { organizer } from './../../../services/api';
let apiOrganizer = new organizer();

var token = localStorage.getItem("user_token");

class FormRecusa extends Component {

    //Estados da classe
    constructor() {
        super();
        this.state = {
            status: "Recusada",
            refusal_notes: "",
        };
        this.handleChange = this.handleChange.bind(this);
    }

    //Metodo handle change do input
    handleChange = evt => {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    //Metodo handle submit do button
    //api.post(`/professional/)`

    handleSubmit = event => {
        event.preventDefault();
        console.log(this.props.exam_id);

        const data = {
            status: this.state.status,
            refusal_notes: this.state.refusal_notes,
        }

        //console.log(data);
        // make API call
        //console.log("Data do input: " + data.password + " " + aux.confirmPassword);
        //console.log(medico_id);
        //api.patch(`/exam/${this.props.exam_id}`, data, {headers: {'x-access-token': token, 'op': "set"} })
        apiOrganizer.editExam(data, this.props.exam_id, "set")
            .then(res => {
                //console.log(res);
                //console.log(res.data);
                alert("Consulta recusada com sucesso!");
                this.props.history.push("/Tela_OG");
            })


    }


    //Render method
    render() {
        return (

            <Fragment>
                <br></br>

                <form onSubmit={this.handleSubmit} id="forms-RI-Cadastro">
                    <h1 id="tittle-forms-cme">Formulário Recusar Consulta</h1>

                    <p id="RI-Title-Cadastro" >Insira o motivo para recusar a consulta</p>
                    <input onChange={this.handleChange} name="refusal_notes" placeholder="Insira aqui sua observação: " id="RI-Cadastro" required />

                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button onClick={() => this.handleSubmit} id="recusar-button">RECUSAR</button>
                    </div>
                </form>
            </Fragment>
        )
    }
}
export default withRouter(FormRecusa);